import React from "react";

import "./Footer.css";

function Footer() {
  return (
    <div className="footer">
      <div className="footer-country">
        <b>Other Countries </b>Pakistan - South Africa - Indonesia
      </div>
      <div className="footer-olx">All rights reserved © 2006-2022 OLX</div>
    </div>
  );
}

export default Footer;
